import React from "react";
import { Formik } from "formik";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField, Paper, withStyles, Button, Typography, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import { BackButton } from '../../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    rootProfile: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(0)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

const AddressForm = props => {
    const { classes, profile, formSettings, usStatesList, countryList, initialValues, handleSubmit, translations } = props;
    return (
        <Paper className={profile ? classes.rootProfile : classes.root}>
            {profile ? null : BackButton(translations)}
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize={true}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors,setFieldValue, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <Autocomplete
                                name="Country"
                                margin={"dense"}
                                options={countryList ? [...countryList] : []}
                                value={values?.Country || ''}
                                onChange={(_event, newValue) => {
                                    setFieldValue('Country', newValue);
                                }}
                                getOptionLabel={option => ((option ? option?.value : '') || '')}
                                renderInput={params => <TextField {...params} label={translations['country'] || 'Country'} margin="dense" fullWidth={true} />}
                            />

                            { values?.Country && values?.Country['key'] === 'US' ?
                                <Autocomplete
                                    name="State"
                                    margin={"dense"}
                                    options={usStatesList ? [...usStatesList] : []}
                                    value={values?.State || ''}
                                    onChange={(_event, newValue) => {
                                        setFieldValue('State', newValue);
                                    }}
                                    getOptionLabel={option => option?.value || ''}
                                    renderInput={params => <TextField {...params} label={translations['state'] || 'State'} margin="dense" fullWidth={true} />}
                                /> : null}


                            <TextField
                                name="City"
                                value={values.City}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.City && touched.City)}
                                placeholder={translations['city'] || 'City'}
                                label={translations['city'] || 'City'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                    
                            <TextField
                                name="AddressLine1"
                                value={values.AddressLine1}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.AddressLine1 && touched.AddressLine1)}
                                placeholder={translations['address_line1'] || 'Address Line 1'}
                                label={translations['address_line1'] || 'Address Line 1'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="AddressLine2"
                                value={values.AddressLine2}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.AddressLine2 && touched.AddressLine2)}
                                placeholder={translations['address_line2'] || 'Address Line 2'}
                                label={translations['address_line2'] || 'Address Line 2'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="GLN"
                                value={values.GLN}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.GLN && touched.GLN)}
                                placeholder={translations['gln'] || 'GLN'}
                                label={translations['gln'] || 'GLN'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        fullWidth={true}
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};
export default withStyles(styles, { withTheme: true })(AddressForm);
